import { render, staticRenderFns } from "./AsyncTaskNotificationCard.vue?vue&type=template&id=625504aa&scoped=true"
import script from "./AsyncTaskNotificationCard.vue?vue&type=script&lang=ts"
export * from "./AsyncTaskNotificationCard.vue?vue&type=script&lang=ts"
import style0 from "./AsyncTaskNotificationCard.vue?vue&type=style&index=0&id=625504aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625504aa",
  null
  
)

export default component.exports